/**
 * Admin Factory-Variant Availability Page
 * Manage which product variants are available at each factory
 */

import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AvailabilityAdminSection } from '@ufc/domains/availability'

export const Route = createFileRoute('/admin/availability')({
  component: AvailabilityPage,
})

function AvailabilityPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('admin.availability.title', 'Plant Availability')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('admin.availability.subtitle', 'Configure which product variants are available at each plant')}
        </p>
      </div>
      <AvailabilityAdminSection />
    </div>
  )
}
